const activies = {
  path: '/activies',
  redirect: '/activies/index',
  component: () => import('@/layout'),
  children: [
    {
      path: 'children', // 频道页
      name: 'ActiviesChildren',
      meta: { title: '频道页' },
      component: () => import(/* webpackChunkName: "activities" */ '@/pages/activies')
    },
    {
      // path: 'special/:code/active_code/:active_code/:id', // 专题页 ccc已配置的如何处理
      path: 'special', // 专题页
      name: 'special',
      meta: { title: '专题页' },
      component: () => import(/* webpackChunkName: "activities" */ '@/pages/activies/special')
    },
    {
      path: 'seckill', // 秒杀页
      name: 'seckill',
      meta: { title: '秒杀页' },
      component: () => import(/* webpackChunkName: "activities" */ '@/pages/activies/seckill')
    },
    {
      path: 'live', // 直播页
      name: 'live',
      meta: { title: '视频页' },
      component: () => import(/* webpackChunkName: "activities" */ '@/pages/activies/live')
    },
    {
      path: 'cooperationList',
      name: 'cooperationList',
      meta: { title: '对外协作' },
      component: () =>
        import(/* webpackChunkName: "activities" */ '@/pages/activies/textList/list.vue')
    },
    {
      path: 'cooperationDetail',
      name: 'cooperationDetail',
      meta: { title: '对外协作' },
      component: () =>
        import(/* webpackChunkName: "activities" */ '@/pages/activies/textList/detail.vue')
    },
    {
      path: 'crm',
      name: 'crm',
      meta: { title: '带你到中国进口厂家专区' },
      component: () => import(/* webpackChunkName: "activities" */ '@/pages/activies/crm.vue')
    }
  ]
}

export default activies
